import { getCurrentCulture } from '../../node_modules/@vp/culture-resolution/build/module/lib/culture.js';
import { DEV_MODE } from '../../constants/general.js';

class AuthProvider{static initAuthConfig(){const windowLocationOrigin=typeof window!==`undefined`?window.location.origin+window.location.pathname:null;const config={options:{requireSession:true},culture:getCurrentCulture(),developmentMode:DEV_MODE?{}:false};if(DEV_MODE){config.developmentMode.clientID="4573b510acfe3f7c2767426de05828bc";config.developmentMode.domain="oauth.cimpress.io";config.developmentMode.redirectUriOrigin=windowLocationOrigin;}return config}}

export { AuthProvider as default };
//# sourceMappingURL=AuthProvider.js.map
